module.exports = __webpack_public_path__ + "img/type_end1.c61945cb.png";